
<div class="mr-emails-settings">
  <div class="mr-emails-settings-header">
    <div class="label">Material Request Emails</div>
  </div>
  <div>
    Here you can set the email addresses for Material Requests. Enter multiple addresses separated by ";", e.g.
    "address1@email.com;address2@email.com"
  </div>

  <div class="emails-group mt-4">
    <div class="label label-bold">MaterialRequest</div>

    <div class="pl-3 pr-3">
      <div class="label label-bold-black">Reply to Address</div>
      <div class="mb-2"><i class="far fa-info-circle"></i> E-Mails sent from a material request will receive replies to this address.</div>
      <input
        @input="isDirty = true"
        type="text"
        class="form-control"
        v-model="entity.materialRequestReplyTo"
        placeholder="Reply to Address"
      />
    </div>

    <div class="mt-3 pl-3 pr-3">
      <div class="label label-bold-black">Request copy to</div>
      <div class="mb-2"><i class="far fa-info-circle"></i> All vendor requests will be sent in copy to this addresses</div>
      <input @input="isDirty = true" type="text" class="form-control" v-model="entity.materialRequestCc" placeholder="Request copy to" />
    </div>

    <div class="mt-3 pl-3 pr-3">
      <div class="label label-bold-black">Blind copy to</div>
      <div class="mb-2"><i class="far fa-info-circle"></i> All vendor requests will be sent in blind copy to this addresses</div>
      <input @input="isDirty = true" type="text" class="form-control" v-model="entity.materialRequestBcc" placeholder="Blind copy to" />
    </div>
  </div>

  <hr />

  <div class="emails-group mt-4">
    <div class="label label-bold">AogDesk Notification</div>

    <div class="pl-3 pr-3">
      <div class="label label-bold-black">Notification To:</div>
      <div class="mb-2"><i class="far fa-info-circle"></i> All change notifications to a material request will be sent to this address</div>
      <input
        @input="isDirty = true"
        type="text"
        class="form-control"
        v-model="entity.materialRequestAogDeskNotificationEmailTo"
        placeholder="Notification To:"
      />
    </div>

    <div class="mt-3 pl-3 pr-3">
      <div class="label label-bold-black">Copy To:</div>
      <div class="mb-2"><i class="far fa-info-circle"></i> All change notifications to a material request will be sent to this address in copy</div>
      <input
        @input="isDirty = true"
        type="text"
        class="form-control"
        v-model="entity.materialRequestAogDeskNotificationEmailCc"
        placeholder="Copy To:"
      />
    </div>
  </div>

  <hr />

  <div class="emails-group mt-4">
    <div class="label label-bold">Management Report</div>

    <div class="pl-3 pr-3 mb-3">
      <div class="label label-bold-black">Automatic Management Report E-Mail Interval in Minutes</div>
      <div class="mb-2"><i class="far fa-info-circle"></i> The management report will be sent automatically for open material requests in the configured interval.</div>
      <input
        @input="isDirty = true"
        type="number"
        class="form-control"
        v-model="entity.autoManagementReportIntervalMinutes"
        placeholder="Report Interval (in minutes)"
      />
    </div>

    <div class="pl-3 pr-3">
      <div class="label label-bold-black">Management Report To</div>
      <div class="mb-2"><i class="far fa-info-circle"></i> The management report will be sent to these addresses</div>
      <input
        @input="isDirty = true"
        type="text"
        class="form-control"
        v-model="entity.materialRequestManagementReportTo"
        placeholder="Management Report To"
      />
    </div>

    <div class="mt-3 pl-3 pr-3">
      <div class="label label-bold-black">Management Report Copy</div>
      <div class="mb-2"><i class="far fa-info-circle"></i> The management report will be sent to these addresses in copy</div>
      <input
        @input="isDirty = true"
        type="text"
        class="form-control"
        v-model="entity.materialRequestManagementReportCc"
        placeholder="Management Report Copy"
      />
    </div>
  </div>

  <hr />

  <div class="d-flex justify-content-end mt-4">
    <button :disabled="!isDirty" class="btn btn-save btn-sm btn-success" @click="save()">
      <i class="far fa-save"></i>
      Save changes
    </button>
  </div>
</div>
